// extracted by mini-css-extract-plugin
export default {"body":"ErrorPage_body__ZBFzy","card":"ErrorPage_card__M1Ge4"};